import {
  withCompPreviewProps,
  createComponentPreviewMapperModel,
  withCompPreviewInfo,
} from '@wix/editor-elements-integrations';
import {
  FillLayersProps,
  MediaContainerDefinition,
  MediaContainerProps,
  MediaCSSVars,
} from '@wix/thunderbolt-components-native';

const getFillLayersPreviewProps = (
  carmiData: MediaContainerProps,
  { isPlayingAllowed }: { isPlayingAllowed: boolean },
): MediaContainerProps & {
  fillLayers?: FillLayersProps;
  previewWrapperProps?: {
    autoPlayVideo: boolean;
    isPlayingAllowed: boolean;
  };
} => {
  let { fillLayers } = carmiData;
  if (fillLayers.video) {
    fillLayers = JSON.parse(JSON.stringify(fillLayers));
    fillLayers.video!.videoInfo.autoPlay =
      fillLayers.video!.videoInfo.autoPlay && isPlayingAllowed;
    return {
      ...carmiData,
      fillLayers,
      previewWrapperProps: {
        autoPlayVideo: fillLayers.video?.videoInfo.autoPlay as boolean,
        isPlayingAllowed,
      },
    };
  }
  return carmiData;
};

export const props = withCompPreviewProps<
  MediaContainerProps,
  MediaContainerDefinition,
  MediaContainerProps
>()(
  ['isPlayingAllowed', 'compDesign'],
  ({ isPlayingAllowed, compDesign }, carmiData: MediaContainerProps) => {
    const borderWidth = compDesign?.cssStyle?.cssBorder.width;
    const fillLayersPreviewProps = getFillLayersPreviewProps(carmiData, {
      isPlayingAllowed,
    });
    const previewWrapperProps =
      fillLayersPreviewProps.previewWrapperProps || {};

    return {
      ...fillLayersPreviewProps,
      previewWrapperProps: {
        ...previewWrapperProps,
        borderWidth,
      },
    };
  },
);

export const css = withCompPreviewInfo<
  MediaCSSVars,
  MediaContainerDefinition,
  MediaCSSVars
>()(['renderFixedPositionBackgrounds'], (deps, carmiData) => {
  const position = carmiData['--fill-layer-background-media-position'];
  if (position) {
    const isFixed = position === 'fixed' && deps.renderFixedPositionBackgrounds;
    return {
      ...carmiData,
      '--fill-layer-background-media-position': isFixed ? 'fixed' : 'absolute',
    };
  }
  return carmiData;
});

export default createComponentPreviewMapperModel({ props, css });
